exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-link[_v-1a30c967]{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-1a30c967&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Modals/Modal-view-comments.vue
// module id = 407
// module chunks = 0